import React from 'react';
import { useQuoteContext } from '@/dataroom/application/landing/QuoteContext';
import styles from './quoteFormSuccess.scss';

const QuoteFormSuccess = () => {
  const {
    submittedFormValues,
  } = useQuoteContext();

  const {
    // @ts-ignore
    dataroomAmount, currentProvider, companyName, fullName, userEmail, phoneNumber, additionalNotes,
  } = submittedFormValues;

  return (
    <div className={ styles.formSuccessWrp }>
      <div className={ styles.thanksHeaderWrp }>Thank you!</div>
      <div className={ styles.resultWrp }>
        <table className={ styles.resultContent }>
          <tbody>
            <tr>
              <td># of Active Data Rooms:</td>
              <td>{ dataroomAmount }</td>
            </tr>
            <tr>
              <td>Current Provider:</td>
              <td>{ currentProvider }</td>
            </tr>
            <tr>
              <td>Your Company:</td>
              <td>{ companyName }</td>
            </tr>
            <tr>
              <td>Your Name:</td>
              <td>{ fullName }</td>
            </tr>
            <tr>
              <td>Your Email:</td>
              <td>{ userEmail }</td>
            </tr>
            <tr>
              <td>Call-Back Number:</td>
              <td>{ phoneNumber }</td>
            </tr>
            <tr>
              <td>Additional Notes:</td>
              <td>{ additionalNotes }</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={ styles.promiseTextWrp }>
        Our team will connect with you within thirty minutes as confirmation.
      </div>
    </div>
  );
};

export default QuoteFormSuccess;
